import { EmploymentType } from '@thesavingsgroup/enums/EmploymentType';
import i18n from 'i18next';

type UnemployedTypeOption = {
  name: string;
  value: EmploymentType;
};

export const unemployedTypeOptions: UnemployedTypeOption[] = [
  {
    name: i18n.t('employmentType.disability'),
    value: EmploymentType.DISABILITY,
  },
  {
    name: i18n.t('employmentType.homemaker'),
    value: EmploymentType.HOMEMAKER,
  },
  {
    name: i18n.t('employmentType.retired'),
    value: EmploymentType.RETIRED,
  },
  {
    name: i18n.t('employmentType.student'),
    value: EmploymentType.STUDENT,
  },
  {
    name: i18n.t('employmentType.other'),
    value: EmploymentType.OTHER,
  },
];
